import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SystemSection } from './components/SystemSection';
import { BonusesSection } from './components/BonusesSection';
import { BenefitsSection } from './components/BenefitsSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
const PIXEL_ID = '2226605141499138';
interface AppProps {
  showPurchaseAlerts?: boolean;
}
export function App({
  showPurchaseAlerts = true
}: AppProps) {
  useEffect(() => {
    if (window.fbq) return;
    const n: any = window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const first = document.getElementsByTagName('script')[0];
    first?.parentNode?.insertBefore(script, first);
    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen w-full bg-carbon font-sans text-cream selection:bg-coral selection:text-cream" data-id="element-0" data-mp="33ohzyyz5cstu">
      <noscript data-id="element-1" data-mp="3dkl4ucldv5kh">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" data-mp="3dl4lzr37lpxg" />
      </noscript>

      <Hero data-id="element-3" data-mp="stc8k5naf2of" />
      <main data-id="element-4" data-mp="st2kinlsz5ld">
        <ProblemSection data-id="element-5" data-mp="swqcvjfihlyi" />
        <SystemSection data-id="element-6" data-mp="36859fxwiety" />
        <BonusesSection data-id="element-7" data-mp="35oxut5vn8u6" />
        <BenefitsSection data-id="element-8" data-mp="34x0pdwmt31s" />
        <PricingSection data-id="element-9" data-mp="38b5stwojqcx" />
        <GuaranteeSection data-id="element-10" data-mp="3ud1e95yxri91" />
        <TestimonialsSection data-id="element-11" data-mp="3ubri4mbn8k51" />
        <FAQSection data-id="element-12" data-mp="3ucj8niqdvrog" />
        <FinalCTA data-id="element-13" data-mp="d4nwrk0ubq3z" />
      </main>
      <Footer data-id="element-14" data-mp="d4xr1jsx4jfh" />
      {showPurchaseAlerts && <PurchasePopup data-id="element-15" data-mp="d3wc348s7csh" />}
    </div>;
}